import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar';
import './AdminHome.css';

function AdminHome() {
  const { user } = useAuth();
  const navigate = useNavigate();

  // Redirect if not admin
  if (user && !user.isAdmin) {
    navigate('/');
    return null;
  }

  const adminSections = [
    {
      id: 'users',
      title: 'User Management',
      icon: '👥',
      description: 'Manage users, subscriptions, and customer data',
      route: '/admin/users',
      color: '#3b82f6',
      available: true,
    },
    {
      id: 'announcements',
      title: 'Announcements',
      icon: '📢',
      description: 'Create and manage notifications for users',
      route: '/admin/announcements',
      color: '#f97316',
      available: true,
    },
    {
      id: 'seasons',
      title: 'Manage Seasons',
      icon: '📅',
      description: 'Configure available seasons for team creation',
      route: '/admin/seasons',
      color: '#10b981',
      available: true,
    },
    {
      id: 'agegroups',
      title: 'Manage Age Groups',
      icon: '⚾🥎',
      description: 'Configure available age groups for team creation',
      route: '/admin/agegroups',
      color: '#06b6d4',
      available: true,
    },
    {
      id: 'reports',
      title: 'Reports & Analytics',
      icon: '📊',
      description: 'View metrics, trends, and business insights',
      route: '/admin/reports',
      color: '#8b5cf6',
      available: true,
    },
    {
      id: 'settings',
      title: 'System Settings',
      icon: '⚙️',
      description: 'Configure platform settings and preferences',
      route: '/admin/settings',
      color: '#64748b',
      available: false, // Coming soon
    },
  ];

  return (
    <div className="admin-home-page">
      <Navbar />
      <div className="admin-home-container">
        <header className="admin-home-header">
          <div className="admin-home-title">
            <div className="admin-icon">🛡️</div>
            <div>
              <h1>Admin Portal</h1>
              <p>Manage your platform and users</p>
            </div>
          </div>
        </header>

        <div className="admin-sections-grid">
          {adminSections.map((section) => (
            <div
              key={section.id}
              className={`admin-section-card ${
                !section.available ? 'disabled' : ''
              }`}
              onClick={() => section.available && navigate(section.route)}
              style={{ borderLeftColor: section.color }}
            >
              <div className="section-icon" style={{ color: section.color }}>
                {section.icon}
              </div>
              <div className="section-content">
                <h3>{section.title}</h3>
                <p>{section.description}</p>
                {!section.available && (
                  <span className="coming-soon-badge">Coming Soon</span>
                )}
              </div>
              {section.available && (
                <div className="section-arrow" style={{ color: section.color }}>
                  →
                </div>
              )}
            </div>
          ))}
        </div>

        <footer className="admin-home-footer">
          <p>
            Logged in as <strong>{user?.email}</strong>
          </p>
        </footer>
      </div>
    </div>
  );
}

export default AdminHome;
